import React, { useCallback, useEffect, useState } from 'react';
import { Box, Flex, useDisclosure } from '@chakra-ui/react';

import { ConfirmationDialog } from '../components/organisms/ConfirmationDialog';
import { MailingListBrowseWindow } from '../components/organisms/Maintenance/BrowseWindow/MailingListBrowseWindow';
import MailingListCreateWindow from '../components/organisms/Maintenance/CreateWindow/MailingListCreateWindow';
import MailingListEditWindow from '../components/organisms/Maintenance/EditWindow/MailingListEditWindow';
import {
  MaintenanceHeader,
  selectTabEnum
} from '../components/organisms/Maintenance/MaintenanceHeader';
import { MaintenanceTitle } from '../components/organisms/Maintenance/MaintenanceTitle';
import MailingListSearchBox from '../components/organisms/Maintenance/SearchWindow/MailingListSearchBox';
import {
  MailingListType,
  MaintenanceMailingListTable
} from '../components/organisms/Maintenance/Table/MaintenanceMailingListTable';
import { DeleteMailingListsApi } from '../apis/DeleteMaintenance.api';
import { GetMailingListApi } from '../apis/GetMaintenance.api';
import { chooseDataStateType } from '../components/molecules/MaintenanceModalDispLabels';

export type MailingListStateType = {
  type: 'mailingList';
  mailingList: MailingListType;
};

export type MailingListArrayStateType = {
  type: 'mailingList';
  mailingList: MailingListType[] | undefined;
};

export interface MailingListSearchCondition {
  sort: { key: string; sortType: boolean };
  email: string;
  enable: boolean;
  dateCreatedFrom: string;
  dateCreatedTo: string;
  dateUpdatedFrom: string;
  dateUpdatedTo: string;
}

export const MailingListMaintenance: React.FC = () => {
  const [query, setQuery] = useState<MailingListSearchCondition>({
    sort: { key: '', sortType: false },
    email: '',
    enable: false,
    dateCreatedFrom: '',
    dateCreatedTo: '',
    dateUpdatedFrom: '',
    dateUpdatedTo: ''
  });

  const [createOrUpdate, setCreateOrUpdate] = useState(false);

  const CreateOrUpdateStateSwitch = useCallback(() => {
    setQuery({
      sort: { key: '', sortType: false },
      email: '',
      enable: false,
      dateCreatedFrom: '',
      dateCreatedTo: '',
      dateUpdatedFrom: '',
      dateUpdatedTo: ''
    });
    setCreateOrUpdate(!createOrUpdate);
  }, [createOrUpdate]);

  const [searchSwitch, setSearchSwitch] = useState(false);

  const SearchStateSwitch = useCallback(() => {
    setSearchSwitch(!searchSwitch);
  }, [searchSwitch]);

  const stateUpdate = (data: chooseDataStateType) => {
    if (data.type === 'mailingList') {
      setChooseData(data.mailingList);
    }
  };
  const DeleteApi = async () => {
    if (chooseData?.id !== undefined) {
      const response = await DeleteMailingListsApi(chooseData.id);
      if (response.success) {
        setMaintenanceDatas(response.data as MailingListType[]);
        CreateOrUpdateStateSwitch();
      }
    }
  };
  const {
    isOpen: isOpenCreate,
    onOpen: onOpenCreate,
    onClose: onCloseCreate
  } = useDisclosure();
  const {
    isOpen: isOpenBrowse,
    onOpen: onOpenBrowse,
    onClose: onCloseBrowse
  } = useDisclosure();
  const {
    isOpen: isOpenEdit,
    onOpen: onOpenEdit,
    onClose: onCloseEdit
  } = useDisclosure();
  const {
    isOpen: isOpenConfirm,
    onOpen: onToggle,
    onClose: onCloseConfirm
  } = useDisclosure();
  const [chooseData, setChooseData] = useState<MailingListType>();
  const [maintenanceDatas, setMaintenanceDatas] = useState<
    MailingListType[] | undefined
  >();

  const GetApi = async () => {
    const response = await GetMailingListApi();
    if (response.success) {
      setMaintenanceDatas(response.data as MailingListType[]);
    }
  };

  useEffect(() => {
    GetApi();
  }, []);

  return (
    <>
      <Flex direction='column' h='100vh'>
        <MaintenanceHeader selectTab={selectTabEnum.MailingList} />
        <MaintenanceTitle
          selectTab={selectTabEnum.MailingList}
          onOpen={onOpenCreate}
        />
        <Box
          position='relative'
          display='grid'
          gridTemplateRows='0.1fr 2fr 0.1fr'
          gridTemplateColumns='3fr 1fr'
          h='100%'
        >
          <MaintenanceMailingListTable
            MailingListDatas={maintenanceDatas}
            setMaintenanceDatas={setMaintenanceDatas}
            setChooseData={stateUpdate}
            onOpenBrowse={onOpenBrowse}
            onOpenEdit={onOpenEdit}
            onToggle={onToggle}
            Query={query}
            setQuery={setQuery}
            createOrUpdate={createOrUpdate}
            searchSwitch={searchSwitch}
          />

          <MailingListSearchBox
            setMaintenanceDatas={setMaintenanceDatas}
            Query={query}
            setQuery={setQuery}
            createOrUpdate={createOrUpdate}
            SearchStateSwitch={SearchStateSwitch}
          />

          {isOpenCreate && (
            <MailingListCreateWindow
              isOpen={isOpenCreate}
              onClose={onCloseCreate}
              setMaintenanceDatas={setMaintenanceDatas}
              CreateOrUpdateStateSwitch={CreateOrUpdateStateSwitch}
            />
          )}
          {isOpenBrowse && (
            <MailingListBrowseWindow
              isOpen={isOpenBrowse}
              onClose={onCloseBrowse}
              BrowseData={chooseData}
            />
          )}

          {isOpenEdit && (
            <MailingListEditWindow
              isOpen={isOpenEdit}
              onClose={onCloseEdit}
              EditData={chooseData}
              setMaintenanceDatas={setMaintenanceDatas}
              CreateOrUpdateStateSwitch={CreateOrUpdateStateSwitch}
            />
          )}
          {isOpenConfirm && (
            <ConfirmationDialog
              isOpen={isOpenConfirm}
              onClose={onCloseConfirm}
              dispMessage={'本当に削除しますか？'}
              DeleteApi={DeleteApi}
            />
          )}
        </Box>
      </Flex>
    </>
  );
};
